import cls from './promoCode.module.scss';
import { Form } from 'react-bootstrap';
import { Icon, Button } from 'lb-components';
import { PromoIcon } from '../../../../assets/icons/menu';
import { UseAlert, UseOTP, UseUser, UseVerification } from 'lb-store/src/hooks';
import { Api } from 'lb-store';

const PromoCode = ({ route, setRoute, navigate, t }) => {
  const { User } = UseUser();
  const verification = UseVerification();
  const otp = UseOTP();
  const alert = UseAlert();

  const promoHandler = (e) => {
    e.preventDefault();

    if (!User.data.verified) {
      alert.open({
        message: t('პრომო კოდის გასააქტიურებლად საჭიროა ვერიფიკაციის გავლა'),
        actionLabel: 'ვერიფიკაცია',
        onSuccess: ({ cancel }) => {
          if (!User.data.isadult) {
            alert.open({
              message: t(
                'ვერიფიკაციის გასავლელად თქვენი ასაკი უნდა აღემატებოდეს 25 წელს'
              ),
              onCancel: () => cancel(),
            });
          } else {
            verification.open({
              onSuccess: () => {
                alert.open({
                  message: t(
                    'დოკუმენტები ატვირთულია მიმდინარეობს ვერიფიკაცია ვერიფიცაკიის შესახებ შეტყობინებას მიიღებთ SMS-ით'
                  ),
                });
                cancel();
              },
            });
          }
        },
      });
    } else {
      const promoCode = e.target.code.value.trim();
      Api.User.PromoCode({ code: promoCode }).then((res) => {
        if (res.status && res.data?.code === 'sms') {
          otp.open({
            onSuccess: (smsCode, callback, close) => {
              Api.User.PromoCode({ code: promoCode, smsCode }).then((res) => {
                if (res.status && res.data.status === 1) {
                  alert.open({
                    //console.log(res);
                    message: t('პრომო კოდი წარმატებით გააქტიურდა'),
                    onCancel: () => close(),
                  });
                } else if (res.data.code === 'sms') {
                  //otp error
                  callback(res.data?.desc);
                } else {
                  //promo code error
                  alert.open({ message: res.data?.desc });
                  close();
                }
              });
            },
            onResend: (callback) => {
              Api.User.PromoCode({ code: promoCode }).then((res) => {
                callback(res.data?.left, res.data?.desc);
              });
            },
          });
        }
      });
    }
  };
  return (
    <div className={cls.promoPage}>
      <div className={cls.icon}>
        <Icon Icon={PromoIcon} width={'6rem'} height={'6rem'} />
      </div>
      <div>{t('გაქვთ პრომო კოდი?')}</div>
      <div className={cls.description}>
        {t(
          'შეიყვანეთ პრომო კოდი მოცემულ ველში! მოგებული თანხა ან FreeSpin დაგერიცხებათ ანგარიშზე.'
        )}
      </div>
      <div className={cls.promoInput}>
        <Form className={cls.form} onSubmit={(e) => promoHandler(e)}>
          <Form.Group>
            <Form.Label>{t('პრომო კოდი')}</Form.Label>
            <Form.Control type='text' name={'code'} className={cls.input} />
            <Button variant='success' type='submit' className={cls.button}>
              {t('პრომოს გააქტიურება')}
            </Button>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
};
export default PromoCode;
